/**
 * 头像图片映射器
 * 用于将预设头像标识符映射为实际的图片资源
 */

// 注意：为了避免循环依赖 (@cubemeet/core <-> @cubemeet/ui)，
// Core 层不再直接导入 UI 层的资源。
// 预设头像的解析逻辑已移至 UI 层 (Avatar 组件)。

/**
 * 获取预设头像资源
 * @param avatarKey - 头像键值，如 'preset_19'
 * @returns 头像资源对象，如果未找到则返回 null
 * @deprecated 请直接使用 @cubemeet/ui 中的 getPresetAvatarAsset
 */
export const getPresetAvatar = (avatarKey: string): any => {
  // Core 层无法直接访问 UI 资源，返回 null
  // 由 UI 层组件自行处理
  return null;
};

/**
 * 检查是否为预设头像
 * @param avatarUrl - 头像URL或键值
 * @returns 是否为预设头像
 */
export const isPresetAvatar = (avatarUrl: string): boolean => {
  return Boolean(avatarUrl && avatarUrl.startsWith('preset_'));
};

/**
 * 获取头像显示资源
 * @param avatarUrl - 头像URL或预设键值
 * @returns 头像显示资源，可能是网络URL或本地资源
 */
export const getAvatarSource = (avatarUrl: string): any => {
  if (!avatarUrl) return null;
  
  // 如果是预设头像，Core 层无法解析，返回 null
  // UI 组件 (Avatar) 会优先尝试从 UI 包解析
  if (isPresetAvatar(avatarUrl)) {
    return null;
  }
  
  // 如果是网络URL
  if (avatarUrl.startsWith('http')) {
    return { uri: avatarUrl };
  }
  
  return null;
};

export default {
  getPresetAvatar,
  isPresetAvatar,
  getAvatarSource,
};
